import classnames from 'classnames';
import React, { useContext } from 'react';

export const CursorContext = React.createContext(-1);

export const Cursor = ({
  start,
  end,
  requestStart,
  requestEnd,
  isRootNode,
}: {
  requestStart: number;
  start: number;
  end: number;
  requestEnd: number;
  isRootNode: boolean;
}) => {
  const cursorTime = useContext(CursorContext);
  const isOnTimeBar = cursorTime >= requestStart && cursorTime <= requestEnd;
  const shouldShowCursor =
    isOnTimeBar && (isRootNode || (cursorTime >= start && cursorTime <= end));

  return (
    <div
      className={classnames('absolute inset-y-0 z-30 flex w-px items-center', {
        hidden: !isOnTimeBar,
      })}
      style={{
        left: `${
          (100 * (cursorTime - requestStart)) / (requestEnd - requestStart)
        }%`,
      }}
    >
      {shouldShowCursor && (
        <div className="h-5 w-px bg-white">
          <div
            style={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              transform: 'translate(-2px, -50%)',
              top: '50%',
            }}
            className="relative bg-white"
          />
        </div>
      )}
    </div>
  );
};
